module.exports = __webpack_public_path__ + "static/media/DSC04227-2.e9778d90.jpg";